import Home from "../../Components/Home/Home";

const Homepage = () => {
  return <Home />;
};

export default Homepage;
